import PropTypes from "prop-types";
import React from "react";
import { Controller } from "react-hook-form";
import { Label } from "reactstrap";
import HubSelect from "../HubSelect";
import MessageFormValidateV2 from "../MessageFormValidateV2";

/**
 * @param {object} props
 * @param {object} props.mainForm
 * @param {string} props.fieldName
 * @param {function} props.t
 * @param {boolean} props.isDisabled
 * @param {boolean} props.isRequired
 * @param {boolean} props.isMultiple
 * @param {?function} props.onBlur
 * @param {?function} props.onChange
 * @param {string} props.title
 * @param {boolean} props.isLabel
 * @param {boolean} props.isError
 * @param {boolean} props.isClearable
 * @param {any} props.hubIdDefault
 * @param {boolean} props.isMyHubOnly
 * @param {number} props.addressLevel
 * @param {number} props.addressLevelHub
 * @param {string} props.provinceCode
 * @param {string} props.districtCode
 */
const FormHubSelect = props => {
  const {
    mainForm,
    fieldName,
    t,
    isDisabled,
    isRequired,
    isMultiple,
    onChange,
    onBlur,
    title,
    isLabel,
    isError,
    isClearable,
    hubIdDefault,
    isMyHubOnly,
    addressLevel,
    addressLevelHub,
    provinceCode,
    districtCode,
  } = props;

  const {
    formState: { errors, touchedFields },
    control,
    setValue,
    watch,
  } = mainForm;

  const data = watch(fieldName);

  return (
    <div className={`${isLabel ? "mb-3" : ""}`}>
      {isLabel && (
        <Label htmlFor={fieldName}>
          {title || t(`form.${fieldName}`)}{" "}
          {isRequired && <span className="text-danger">*</span>}
        </Label>
      )}
      <Controller
        control={control}
        name={fieldName}
        render={({ field }) => {
          if (onChange) {
            return (
              <HubSelect
                {...field}
                value={data}
                fieldName={fieldName}
                hubIdDefault={hubIdDefault}
                setValue={setValue}
                isDisabled={isDisabled}
                isMyHubOnly={isMyHubOnly}
                onChange={onChange}
                onBlur={onBlur || field.onBlur}
                addressLevel={addressLevel}
                addressLevelHub={addressLevelHub}
                provinceCode={provinceCode}
                districtCode={districtCode}
              />
            );
          }
          return (
            <HubSelect
              {...field}
              value={data}
              fieldName={fieldName}
              hubIdDefault={hubIdDefault}
              setValue={setValue}
              isDisabled={isDisabled}
              isMyHubOnly={isMyHubOnly}
              onBlur={onBlur || field.onBlur}
              addressLevel={addressLevel}
              addressLevelHub={addressLevelHub}
              provinceCode={provinceCode}
              districtCode={districtCode}
            />
          );
        }}
      />
      {isError && (
        <MessageFormValidateV2 errors={errors} fieldName={fieldName} />
      )}
    </div>
  );
};

FormHubSelect.propTypes = {
  mainForm: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isMultiple: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  title: PropTypes.string,
  isLabel: PropTypes.bool,
  isError: PropTypes.bool,
  isClearable: PropTypes.bool,
  hubIdDefault: PropTypes.any,
  isMyHubOnly: PropTypes.bool,
  addressLevel: PropTypes.number,
  provinceCode: PropTypes.string,
  districtCode: PropTypes.string,
};

FormHubSelect.defaultProps = {
  isDisabled: false,
  isRequired: false,
  isMultiple: false,
  onChange: undefined,
  onBlur: undefined,
  title: "",
  isLabel: true,
  isError: true,
  isClearable: true,
  isMyHubOnly: false,
  addressLevel: 3,
  provinceCode: "",
  districtCode: "",
};

export default FormHubSelect;
